/** Frontend-only mode — no API/socket; use local seed data. */
export const isStaticDataMode = () => {
  const flag = String(process.env.REACT_APP_USE_STATIC_DATA || "").trim().toLowerCase();
  return flag === "1" || flag === "true" || flag === "yes";
};
